module.exports = __webpack_public_path__ + "ionicons.2c159d0d05473040b53e.woff";


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/assets/fonts/ionicons.woff?v=2.0.1
// module id = ../../../../../src/assets/fonts/ionicons.woff?v=2.0.1
// module chunks = styles